export default __webpack_public_path__ + "static/media/SouzaPilares.bc62e466.svg";